export const tabsStyles = {
  '&.MuiTabs-root': {
    minHeight: 40,
    fontFamily: ({ typography }) => typography.fontFamily,
    fontSize: 16,
    fontWeight: ({ typography }) => typography.fontWeightRegular,
    lineHeight: 1.5,
    color: ({ palette }) => palette.text.secondary,
    borderBottom: 1,
    borderColor: 'divider',
  },
};

export const tabStyles = {
  '&.MuiTab-root': {
    minHeight: 40,
    py: 1,
    px: 2,
    font: 'inherit',
    textTransform: 'capitalize',
  },

  '&.Mui-selected': {
    color: ({ palette }) => palette.text.primary,
    fontWeight: ({ typography }) => typography.fontWeightMedium,
  },
};
